/**
 * @generated SignedSource<<753cae7d178948e75772415b2745f358>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SiteLocale = "en_GB" | "sv_SE" | "%future added value";
export type TopicArticlesQuery$variables = {
  locale?: SiteLocale | null | undefined;
  topicId?: string | null | undefined;
};
export type TopicArticlesQuery$data = {
  readonly articles: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"Article_article" | "TopicTableOfContents_articles">;
  }>;
};
export type TopicArticlesQuery = {
  response: TopicArticlesQuery$data;
  variables: TopicArticlesQuery$variables;
};
({
  "__relay_internal__pv__ImageRecord_lgImageSize_relayprovider": lgImgWidth_provider,
  "__relay_internal__pv__ImageRecord_mdImageSize_relayprovider": mdImgWidth_provider,
  "__relay_internal__pv__ImageRecord_smImageSize_relayprovider": smImgWidth_provider
} as {
  readonly __relay_internal__pv__ImageRecord_lgImageSize_relayprovider: {
    readonly get: () => any | null | undefined;
  };
  readonly __relay_internal__pv__ImageRecord_mdImageSize_relayprovider: {
    readonly get: () => any | null | undefined;
  };
  readonly __relay_internal__pv__ImageRecord_smImageSize_relayprovider: {
    readonly get: () => any | null | undefined;
  };
});

import lgImgWidth_provider from './../image-record/ImageRecord_lgImageSize_relayprovider';
import mdImgWidth_provider from './../image-record/ImageRecord_mdImageSize_relayprovider';
import smImgWidth_provider from './../image-record/ImageRecord_smImageSize_relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topicId"
},
v2 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "eq",
            "variableName": "topicId"
          }
        ],
        "kind": "ObjectValue",
        "name": "topic"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
],
v8 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "TextRecord",
  "abstractKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headerText",
      "storageKey": null
    }
  ],
  "type": "HeadingRecord",
  "abstractKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "src",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "base64",
    "storageKey": null
  },
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "caption",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FileField",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v5/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alt",
          "storageKey": null
        },
        {
          "alias": "lgImg",
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "w",
                  "variableName": "__relay_internal__pv__ImageRecord_lgImageSize_relayprovider"
                }
              ],
              "kind": "ObjectValue",
              "name": "imgixParams"
            }
          ],
          "concreteType": "ResponsiveImage",
          "kind": "LinkedField",
          "name": "responsiveImage",
          "plural": false,
          "selections": (v12/*: any*/),
          "storageKey": null
        },
        {
          "alias": "mdImg",
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "w",
                  "variableName": "__relay_internal__pv__ImageRecord_mdImageSize_relayprovider"
                }
              ],
              "kind": "ObjectValue",
              "name": "imgixParams"
            }
          ],
          "concreteType": "ResponsiveImage",
          "kind": "LinkedField",
          "name": "responsiveImage",
          "plural": false,
          "selections": (v12/*: any*/),
          "storageKey": null
        },
        {
          "alias": "smImg",
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "w",
                  "variableName": "__relay_internal__pv__ImageRecord_smImageSize_relayprovider"
                }
              ],
              "kind": "ObjectValue",
              "name": "imgixParams"
            }
          ],
          "concreteType": "ResponsiveImage",
          "kind": "LinkedField",
          "name": "responsiveImage",
          "plural": false,
          "selections": (v12/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ImageRecord",
  "abstractKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "PreambleRecord",
  "abstractKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "HelpCenterTopicRecord",
  "kind": "LinkedField",
  "name": "topic",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpCenterArticleRecord",
      "kind": "LinkedField",
      "name": "articleLink",
      "plural": false,
      "selections": [
        (v15/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ArticleLinkRecord",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicArticlesQuery",
    "selections": [
      {
        "alias": "articles",
        "args": (v2/*: any*/),
        "concreteType": "HelpCenterArticleRecord",
        "kind": "LinkedField",
        "name": "allHelpCenterArticles",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Article_article"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TopicTableOfContents_articles"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__ImageRecord_lgImageSize_relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__ImageRecord_mdImageSize_relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__ImageRecord_smImageSize_relayprovider"
      }
    ],
    "kind": "Operation",
    "name": "TopicArticlesQuery",
    "selections": [
      {
        "alias": "articles",
        "args": (v2/*: any*/),
        "concreteType": "HelpCenterArticleRecord",
        "kind": "LinkedField",
        "name": "allHelpCenterArticles",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "content",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isHelpCenterArticleModelContentField"
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HelpCenterArticleModelArticleContentField",
            "kind": "LinkedField",
            "name": "articleContent",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HelpCenterArticleRecord",
                "kind": "LinkedField",
                "name": "links",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v3/*: any*/),
                  (v5/*: any*/),
                  (v4/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "blocks",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v9/*: any*/),
                  (v16/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VideoField",
                        "kind": "LinkedField",
                        "name": "video",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "provider",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "providerUid",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          (v11/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "VideoRecord",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a8dd065192da60a379208450ee5156a6",
    "id": null,
    "metadata": {},
    "name": "TopicArticlesQuery",
    "operationKind": "query",
    "text": "query TopicArticlesQuery(\n  $topicId: ItemId\n  $locale: SiteLocale\n  $__relay_internal__pv__ImageRecord_lgImageSize_relayprovider: FloatType\n  $__relay_internal__pv__ImageRecord_mdImageSize_relayprovider: FloatType\n  $__relay_internal__pv__ImageRecord_smImageSize_relayprovider: FloatType\n) {\n  articles: allHelpCenterArticles(locale: $locale, filter: {topic: {eq: $topicId}}) {\n    id\n    ...Article_article\n    ...TopicTableOfContents_articles\n  }\n}\n\nfragment ArticleContentOld_content on HelpCenterArticleModelContentField {\n  __isHelpCenterArticleModelContentField: __typename\n  __typename\n  ...TextRecord_content\n  ...HeadingRecord_content\n  ...ImageRecord_content\n  ...PreambleRecord_content\n  ...ArticleLinkRecord_content\n}\n\nfragment ArticleContent_articleContent on HelpCenterArticleModelArticleContentField {\n  value\n  links {\n    __typename\n    id\n    url\n    title\n    topic {\n      url\n    }\n  }\n  blocks {\n    __typename\n    ...HeadingRecord_content\n    ...ArticleLinkRecord_content\n    ...ImageRecord_content\n    ...PreambleRecord_content\n    ...TextRecord_content\n    ... on HeadingRecord {\n      id\n    }\n    ... on ArticleLinkRecord {\n      id\n    }\n    ... on ImageRecord {\n      id\n    }\n    ... on PreambleRecord {\n      id\n    }\n    ... on VideoRecord {\n      id\n      video {\n        provider\n        title\n        providerUid\n        url\n        width\n        height\n      }\n    }\n    ... on TextRecord {\n      id\n    }\n  }\n}\n\nfragment ArticleLinkRecord_content on ArticleLinkRecord {\n  id\n  linkText\n  articleLink {\n    topic {\n      url\n    }\n    url\n  }\n}\n\nfragment Article_article on HelpCenterArticleRecord {\n  id\n  title\n  url\n  content {\n    __typename\n    ...ArticleContentOld_content\n  }\n  articleContent {\n    ...ArticleContent_articleContent\n  }\n}\n\nfragment HeadingRecord_content on HeadingRecord {\n  id\n  headerText\n}\n\nfragment ImageRecord_content on ImageRecord {\n  id\n  caption\n  image {\n    id\n    url\n    title\n    alt\n    lgImg: responsiveImage(imgixParams: {w: $__relay_internal__pv__ImageRecord_lgImageSize_relayprovider}) {\n      src\n      base64\n      height\n      width\n    }\n    mdImg: responsiveImage(imgixParams: {w: $__relay_internal__pv__ImageRecord_mdImageSize_relayprovider}) {\n      src\n      base64\n      height\n      width\n    }\n    smImg: responsiveImage(imgixParams: {w: $__relay_internal__pv__ImageRecord_smImageSize_relayprovider}) {\n      src\n      base64\n      height\n      width\n    }\n  }\n}\n\nfragment PreambleRecord_content on PreambleRecord {\n  id\n  text\n}\n\nfragment TextRecord_content on TextRecord {\n  id\n  text\n}\n\nfragment TopicTableOfContents_articles on HelpCenterArticleRecord {\n  id\n  title\n  url\n}\n",
    "providedVariables": {
      "__relay_internal__pv__ImageRecord_lgImageSize_relayprovider": lgImgWidth_provider,
      "__relay_internal__pv__ImageRecord_mdImageSize_relayprovider": mdImgWidth_provider,
      "__relay_internal__pv__ImageRecord_smImageSize_relayprovider": smImgWidth_provider
    }
  }
};
})();

(node as any).hash = "aa4bd8158d3f868770205bda0bc82e96";

export default node;
